module.exports = __webpack_public_path__ + "img/dzp.746ad682.png";